export default __webpack_public_path__ + "static/media/Universidad_Peruana_de_Ciencias_Aplicadas.c1e937c1.png";